import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
const { persistAtom } = recoilPersist({
  key: "recoil-persist",
  storage: localStorage,
  converter: JSON,
});

export const appAtom = atom({
  key: "appAtom",
  effects_UNSTABLE: [persistAtom],
  default: {
    appBgImageUrl: "",
  },
});
